class WishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      addRemoveButton: "add-to-wishlist",
      wishlistCount: ".wishlist-count-bubble",
      wishlistDrawerEmpty: "#eg-wishlist-drawer-empty",
      drawerProductList: "#eg-wishlist-drawer-product-list",
      drawerOpenButton: "[data-wishlist-drawer-open]",
    };

    this.settings = window.wishlistSettings;
    this.localStorageKey = "eg_wishlist_v1";
    this.wishlistProducts =
      JSON.parse(localStorage.getItem(this.localStorageKey)) || [];

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#WishlistDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    document.addEventListener("wishlist-add", (e) => {
      this.handleAddToWishlist(e.detail.productId, e.detail.productHandle);
      document.querySelector("wishlist-items").refreshDrawer();
    });

    document.addEventListener("wishlist-remove", (e) => {
      console.log(e.detail.productHandle);
      this.handleRemoveFromWishlist(e.detail.productHandle);
      document.querySelector("wishlist-items").refreshDrawer();
    });
  }

  setHeaderCartIconAccessibility() {
    const wishlistLink = document.querySelector("#wishlist-icon");
    if (!wishlistLink) return;

    wishlistLink.setAttribute("role", "button");
    wishlistLink.setAttribute("aria-haspopup", "dialog");
    wishlistLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(wishlistLink);
    });
    wishlistLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(wishlistLink);
      }
    });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("WishlistDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  handleAddToWishlist(productId, productHandle) {
    document
      .querySelectorAll(
        `${this.selectors.addRemoveButton}[data-product-handle="${productHandle}"]`
      )
      .forEach((btn) => {
        btn.querySelector("[data-add]").style.display = "none";
        btn.querySelector("[data-remove]").style.display = "inline-flex";
      });

    this.wishlistProducts.push({ id: productId, handle: productHandle });

    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify(this.wishlistProducts)
    );
  }

  handleRemoveFromWishlist(productHandle) {
    document
      .querySelectorAll(
        `${this.selectors.addRemoveButton}[data-product-handle="${productHandle}"]`
      )
      .forEach((btn) => {
        btn.querySelector("[data-add]").style.display = "inline-flex";
        btn.querySelector("[data-remove]").style.display = "none";
      });

    this.wishlistProducts = this.wishlistProducts.filter(
      (itm) => itm.handle != productHandle
    );

    localStorage.setItem(
      this.localStorageKey,
      JSON.stringify(this.wishlistProducts)
    );
  }

  async addAllProductsToWishlist() {
    if (this.wishlistProducts.length == 0) return;

    fetch(`${routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: this.wishlistProducts.map((itm) => {
          return {
            id: parseFloat(itm.id),
            quantity: 1,
          };
        }),
        sections: "cart-drawer,cart-icon-bubble",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        this.cart.renderContents(data);
        this.close();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("wishlist-drawer", WishlistDrawer);

class WishlistItems extends HTMLElement {
  constructor() {
    super();
    this.refreshDrawer();
  }
  async refreshDrawer() {
    this.innerHTML = "";

    this.wishlistProducts =
      document.querySelector("wishlist-drawer").wishlistProducts;

    document.querySelector(".wishlist-count-bubble").innerHTML =
      this.wishlistProducts.length == 0 ? "" : this.wishlistProducts.length;

    let buildProductListItems = [];

    for (let index = 0; index < this.wishlistProducts.length; index++) {
      const handle = this.wishlistProducts[index].handle;
      const productMarkup = await this.fetchWishlistProductsMarkup(handle);
      buildProductListItems.push(productMarkup);
    }

    this.innerHTML = buildProductListItems.join("");
    // drawerProductList.insertAdjacentHTML(
    //   "afterbegin",
    //   buildProductListItems.join("")
    // );
  }
  async fetchWishlistProductsMarkup(handle) {
    const response = await fetch(
      `/products/${handle}?section_id=wishlist-card-product`
    );
    const product = await response.text();
    return product;
  }
}

customElements.define("wishlist-items", WishlistItems);

class AddToWishlist extends HTMLElement {
  constructor() {
    super();
    this.init();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.handleWishlistButtonClick(event);
    });
  }

  handleWishlistButtonClick(event) {
    const productHandle = this.dataset.productHandle;
    const productId = this.dataset.productId;

    console.log("---------------------");
    console.log(this.wishlistProducts);
    console.log("---------------------");

    if (this.wishlistProducts.find((itm) => itm.handle == productHandle)) {
      document.dispatchEvent(
        new CustomEvent("wishlist-remove", {
          detail: {
            productHandle: productHandle,
            productId: productId,
          },
        })
      );
      // this.handleRemoveFromWishlist(productHandle);
    } else {
      document.dispatchEvent(
        new CustomEvent("wishlist-add", {
          detail: {
            productHandle: productHandle,
            productId: productId,
          },
        })
      );
      // this.handleAddToWishlist(productHandle);
    }
  }

  get wishlistProducts() {
    return document.querySelector("wishlist-drawer").wishlistProducts;
  }

  init() {
    const isWishlisted = this.wishlistProducts.find(
      (itm) => itm.handle === this.dataset.productHandle
    );

    if (isWishlisted) {
      this.querySelector("[data-add]").style.display = "none";
      this.querySelector("[data-remove]").style.display = "inline-flex";
    } else {
      this.querySelector("[data-add]").style.display = "inline-flex";
      this.querySelector("[data-remove]").style.display = "none";
    }
  }
}

customElements.define("add-to-wishlist", AddToWishlist);

class MainWishlist extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      wishlistEmpty: ".wishlist-empty",
      productsList: ".wishlist-products-list",
      addRemoveButton: ".button-add-remove-wishlist",
      wishlistCount: ".wishlist-count-bubble",
      wishlistDrawerEmpty: "#eg-wishlist-drawer-empty",
      drawerProductList: "#eg-wishlist-drawer-product-list",
      drawerOpenButton: "[data-wishlist-drawer-open]",
    };

    this.settings = window.wishlistSettings;
    this.localStorageKey = "eg_wishlist_v1";
    this.wishlistProducts =
      JSON.parse(localStorage.getItem(this.localStorageKey)) || [];

    this.drawer = document.querySelector(this.selectors.drawer);

    this.fetchWishlistProducts();
  }

  initAddtoWishlistButtons() {
    document.querySelectorAll(this.selectors.addRemoveButton).forEach((btn) => {
      const productHandle = btn.closest("[data-product-handle]")?.dataset
        .productHandle;

      const isWishlisted = this.wishlistProducts.some(
        (elem) => elem === productHandle
      );

      if (isWishlisted) {
        btn.querySelector("[data-add]").style.display = "none";
        btn.querySelector("[data-remove]").style.display = "inline-flex";
      } else {
        btn.querySelector("[data-add]").style.display = "inline-flex";
        btn.querySelector("[data-remove]").style.display = "none";
      }

      btn.classList.remove("hidden");
    });
  }

  async fetchWishlistProducts() {
    const wishlistEmpty = this.querySelector(this.selectors.wishlistEmpty);
    const productsList = this.querySelector(this.selectors.productsList);

    if (this.wishlistProducts.length > 0) {
      wishlistEmpty.style.display = "none";
    }

    if (this.wishlistProducts.length === 0) {
      wishlistEmpty.style.display = "block";
      productsList.style.display = "none";
      return;
    }

    let buildProductListItems = [];

    for (let index = 0; index < this.wishlistProducts.length; index++) {
      const handle = this.wishlistProducts[index];
      const productMarkup = await this.fetchWishlistProductsMarkup(handle);
      buildProductListItems.push(productMarkup);
    }

    // return;
    productsList.insertAdjacentHTML(
      "afterbegin",
      buildProductListItems.join("")
    );

    productsList.querySelectorAll(":scope > div").forEach((product, index) => {
      product.style.zIndex = 100 - index;
    });

    productsList.classList.add("loaded");
    window.initCustomVariantPicker();
    window.initCoffeeSamples();
    wishlistEmpty.style.display = "none";
    this.initAddtoWishlistButtons();

    document.querySelectorAll(this.selectors.addRemoveButton).forEach((btn) => {
      btn.addEventListener("click", () => this.handleWishlistButtonClick(btn));
    });
  }

  handleWishlistButtonClick(btn) {
    const productHandle = btn.closest("[data-product-handle]")?.dataset
      .productHandle;

    if (this.wishlistProducts.indexOf(productHandle) > -1) {
      document.dispatchEvent(
        new CustomEvent("wishlist-remove", {
          detail: {
            productHandle: productHandle,
          },
        })
      );

      document
        .querySelector(
          `.wishlist-product-card-wrapper[data-product-handle='${productHandle}']`
        )
        .closest(".shopify-section")
        .remove();
      // this.handleRemoveFromWishlist(productHandle);
    } else {
      document.dispatchEvent(
        new CustomEvent("wishlist-add", {
          detail: {
            productHandle: productHandle,
          },
        })
      );
      // this.handleAddToWishlist(productHandle);
    }
  }
  async fetchWishlistProductsMarkup(handle) {
    const response = await fetch(
      `/products/${handle}?section_id=wishlist-card-product`
    );
    const product = await response.text();
    return product;
  }
}

customElements.define("main-wishlist", MainWishlist);
